interface EquipmentProperty {
  name: string;
  displayValue: string;
  propWrite: (input?: any) => Array<{
    propName: string;
    output: any;
  }>;
  catalogTable: string | null;
  inputType?: string;
  type?: string | undefined;
  step?: number | undefined;
}

const EQUIPMENT_PROPERTY_LIST: EquipmentProperty[] = [
  {
    name: 'damper',
    displayValue: 'Damper',
    propWrite: (input: string) => {
      return [
        {
          propName: 'damper_settings',
          output: { display_value: input },
        },
      ];
    },
    catalogTable: null,
    inputType: 'text',
  },
  {
    name: 'frame',
    displayValue: 'Frame',
    propWrite: (input) => {
      return [
        {
          propName: 'frame_id',
          output: input,
        },
      ];
    },
    catalogTable: 'frames',
  },
  {
    name: 'tyres',
    displayValue: 'Tyres',
    propWrite: (input) => {
      return [
        {
          propName: 'tyre_front_id',
          output: input,
        },
        {
          propName: 'tyre_rear_id',
          output: input,
        },
      ];
    },
    catalogTable: 'tyres',
  },
  {
    name: 'tyre_front',
    displayValue: 'Tyre Front',
    propWrite: (input) => {
      return [
        {
          propName: 'tyre_front_id',
          output: input,
        },
      ];
    },
    catalogTable: 'tyres',
  },
  {
    name: 'tyre_rear',
    displayValue: 'Tyre Rear',
    propWrite: (input) => {
      return [
        {
          propName: 'tyre_rear_id',
          output: input,
        },
      ];
    },
    catalogTable: 'tyres',
  },
  {
    name: 'tyre_pressures',
    displayValue: 'Tyre Pressures',
    propWrite: (input) => {
      return [
        {
          propName: 'tyre_front_pressure',
          output: input,
        },
        {
          propName: 'tyre_rear_pressure',
          output: input,
        },
      ];
    },
    catalogTable: null,
    type: 'number',
    step: 0.1,
  },
  {
    name: 'tyre_front_pressure',
    displayValue: 'Tyre Pressure Front',
    propWrite: (input) => {
      return [
        {
          propName: 'tyre_front_pressure',
          output: input,
        },
      ];
    },
    catalogTable: null,
    type: 'number',
    step: 0.1,
  },
  {
    name: 'tyre_rear_pressure',
    displayValue: 'Tyre Pressure Rear',
    propWrite: (input) => {
      return [
        {
          propName: 'tyre_rear_pressure',
          output: input,
        },
      ];
    },
    catalogTable: null,
    type: 'number',
    step: 0.1,
  },
  {
    name: 'wheel_front',
    displayValue: 'Wheel Front',
    propWrite: (input) => {
      return [
        {
          propName: 'wheel_front_id',
          output: input,
        },
      ];
    },
    catalogTable: 'wheels_front',
  },
  {
    name: 'wheel_rear',
    displayValue: 'Wheel Rear',
    propWrite: (input) => {
      return [
        {
          propName: 'wheel_rear_id',
          output: input,
        },
      ];
    },
    catalogTable: 'wheels_rear',
  },
];

// Create object with name as key
const EQUIPMENT_ITEMS: { [key: string]: EquipmentProperty } = EQUIPMENT_PROPERTY_LIST.reduce(
  (acc, item) => {
    acc[item.name] = item;
    return acc;
  },
  {} as { [key: string]: EquipmentProperty },
);

// Map display values as keys to EQUIPMENT_ITEMS values
const EQUIPMENT_ITEMS_BY_DISPLAY: { [key: string]: EquipmentProperty } = EQUIPMENT_PROPERTY_LIST.reduce(
  (acc, item) => {
    acc[item.displayValue] = item;
    return acc;
  },
  {} as { [key: string]: EquipmentProperty },
);

export { EQUIPMENT_PROPERTY_LIST, EQUIPMENT_ITEMS, EQUIPMENT_ITEMS_BY_DISPLAY };
export type { EquipmentProperty };
